import * as state from './state.js';
let getters = {
    getUserInfoName: state => {
        return state.name;
    },
    getUserSex: state => {
        return state.sex;
    },
    getUserGrade: state => {
    	return state.grade;
    },
    getUserMail: state => {
    	return state.email;
    },
    getUserBirth: state => {
        return state.birth;
    },
    getUserStuNum: state => {
        return state.stu_num
    }
};
export default getters;


// WEBPACK FOOTER //
// ./src/vuex/modules/userInfo/getters.js